import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getArchivedProjectsOfBusiness } from '../services/getArchivedProjectsOfBusiness.service';

export const loadArchivedProjectsOfBusiness = createAsyncThunk(
  'projects/loadArchivedProjectsOfBusiness',
  async (_, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const projectIds = await getArchivedProjectsOfBusiness(activeEmployerInfo);

    return projectIds;
  }
);
